import { ORDER_ITEM_DETAIL, ORDER_ITEM_LIST, ORDER_ITEM_CREATE, ORDER_ITEM_DELETE, ORDER_ITEM_UPDATE, UPDATE_ITEM_INSTOCK_STATUS  } from './itemTypes'
import { URL_ORDER_ITEM_CREATE, URL_ORDER_ITEM_DELETE, URL_ORDER_ITEM_DETAIL, URL_ORDER_ITEM_LIST, URL_ORDER_ITEM_UPDATE, URL_UPDATE_ITEM_INSTOCK } from './itemUrls'
import { ResponseModel, STATUS_OK } from '../../models/network/response_model'
import axios from "../../axios";

/* eslint-disable */
export default {
    [ORDER_ITEM_LIST]({ commit }, item) {
        return new Promise((resolve, reject) => {
            axios.get(URL_ORDER_ITEM_LIST, { params: item })
                .then((response) => {
                    let responseModel = new ResponseModel(response);
                    if (responseModel.status == STATUS_OK) {
                        let resultModel = responseModel.result;
                        if (resultModel.status == STATUS_OK) {
                            let data = resultModel.data;
                            commit(ORDER_ITEM_LIST, data)
                            resolve(data);
                        } else {
                            commit(ORDER_ITEM_LIST, { items: [], _links: {}, _meta: {} });
                            resolve({ items: [], _links: {}, _meta: {} });
                        }
                    } else {
                        commit(ORDER_ITEM_LIST, { items: [], _links: {}, _meta: {} });
                        resolve({ items: [], _links: {}, _meta: {} });
                    }
                })
                .catch((error) => { reject(error); })
        })
    },

    [ORDER_ITEM_DETAIL]({ commit }, params) {
        return new Promise((resolve, reject) => {
            axios.get(URL_ORDER_ITEM_DETAIL, {
                params: params
            }).then((response) => {
                let responseModel = new ResponseModel(response);
                commit(ORDER_ITEM_DETAIL, responseModel.result.data);
                resolve(responseModel.result.data);
            }).catch(error => reject(error));
        })
    },

    [ORDER_ITEM_CREATE]({ dispatch }, item) {
      return new Promise((resolve, reject) => {
        axios.post(`${URL_ORDER_ITEM_CREATE}`, item)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
              let resultModel = responseModel.result;
              if (resultModel.status == STATUS_OK) {
                  let data = resultModel.data;
                  let temp = {
                    page : item.page,
                    "per-page" : item['per-page'],
                  }
                  dispatch(ORDER_ITEM_LIST, temp);
                  resolve(data);
              } else {
                  reject(resultModel.message);
              }
          } else {
              reject(responseModel.message);
          }
        }).catch((error) => { reject(error) });
      })
    },

    [ORDER_ITEM_UPDATE]({ dispatch }, item) {
      return new Promise((resolve, reject) => {
        axios.post(`${URL_ORDER_ITEM_UPDATE}`, item)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
              let resultModel = responseModel.result;
              if (resultModel.status == STATUS_OK) {
                  let data = resultModel.data;
                  let temp = {
                    page : item.page,
                    "per-page" : item['per-page'],
                  }
                  dispatch(ORDER_ITEM_LIST, temp);
                  resolve(data);
              } else {
                  reject(resultModel.message);
              }
          } else {
              reject(responseModel.message);
          }
        }).catch((error) => { reject(error) });
      })
    },

    [ORDER_ITEM_DELETE]({ dispatch }, item) {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      return new Promise((resolve, reject) => {
        axios.post(`${URL_ORDER_ITEM_DELETE}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
              let resultModel = responseModel.result;
              if (resultModel.status == STATUS_OK) {
                  let data = resultModel.data;
                  let temp = {
                    page : item.page,
                    "per-page" : item['per-page'],
                  }
                  dispatch(ORDER_ITEM_LIST, temp);
                  resolve(data);
              } else {
                  reject(resultModel.message);
              }
          } else {
              reject(responseModel.message);
          }
        }).catch((error) => { reject(error) });
      })
    },


    [UPDATE_ITEM_INSTOCK_STATUS]({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            axios.post(URL_UPDATE_ITEM_INSTOCK, data)
                .then((response) => {
                    let responseModel = new ResponseModel(response);
                    if (responseModel.status == STATUS_OK) {
                        let resultModel = responseModel.result;
                        if (resultModel.status == STATUS_OK) {
                            let data = resultModel.data;
                            dispatch(ORDER_ITEM_LIST);
                            resolve(data);
                        } else {
                            reject(resultModel.message);
                        }
                    } else {
                        reject(responseModel.message);
                    }
                })
                .catch((error) => { reject(error) });
        })
    }
}
